import React, { useEffect } from "react";
import { TbMessageReportFilled } from "react-icons/tb";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { FaCookieBite } from "react-icons/fa";
import { FaDatabase } from "react-icons/fa";
import { IoHandRightSharp } from "react-icons/io5";
import { RiLinksLine } from "react-icons/ri";
import { MdPrivacyTip } from "react-icons/md";
import { SiWondersharefilmora } from "react-icons/si";
import "../Style/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="privacy-container">
      <div className="aboutus-border"></div>
      <div className="first-section">
        <div>
          <h1 className="f-h1" style={{ color: "var(--primary-color)" }}>
            Privacy <span>Policy</span>
          </h1>
          <p style={{ fontSize: "12px", textAlign: "center" }}>
            Last Updated 11/03/2025
          </p>
        </div>
        <div>
          <p>
            At Homoeopathic Health Care & Research Center, we value your privacy
            and are committed to protecting your personal information. This
            Privacy Policy explains how we collect, use, store, and protect your
            data when you use our website.
          </p>
        </div>
      </div>
      <div className="privacy-first-cont">
        <div className="privacy-first-first">
          <div>
            <TbMessageReportFilled
              style={{ fontSize: "30px", color: "var(--primary-color)" }}
            />
          </div>
          <div>
            <h1 className="p-h1">1. Information we collect</h1>
            <p className="p-span">
              We may collect various types of information, including:
            </p>
            <p className="p-span">Personal Information:</p>
            <p className="pr-p">
              Name, contact details (such as email address, phone number), and
              billing information.
            </p>
            <p className="p-span">Technical Data:</p>
            <p>
              IP address, browser type, operating system, and usage data to help
              us improve website functionality and user experience.
            </p>
            <p className="p-span">Service Information: </p>
            <p>
              Details related to your vehicle, service history, and feedback on
              our services.
            </p>
          </div>
        </div>

        <div className="privacy-first-second">
          <div>
            <IoMdInformationCircleOutline
              style={{ fontSize: "30px", color: "var(--primary-color)" }}
            />
          </div>
          <div>
            <h1 className="p-h1">2. How We Use Your Information</h1>
            <p className="p-span">We use your information to:</p>
            <p>Provide, operate, and maintain our services.</p>
            <p>Process transactions and provide customer support.</p>
            <p>
              Send you service-related communications, including updates and
              promotions.
            </p>
            <p>
              Analyze website usage and optimize our content to improve customer
              experience.
            </p>
          </div>
        </div>

        <div className="privacy-first-first">
          <div>
            <SiWondersharefilmora
              style={{ fontSize: "30px", color: "var(--primary-color)" }}
            />
          </div>
          <div>
            <h1 className="p-h1">3. Data Sharing and Disclosure</h1>
            <p className="p-span">Your information will only be shared:</p>

            <ul style={{ marginLeft: "25px" }}>
              <li>
                With third-party providers who assist us in service delivery
                (e.g., payment processors, couriers).
              </li>
              <li>
                When required by law, to protect rights and safety, or as part
                of a business transaction, such as a merger.
              </li>
            </ul>
            <p>
              We never sell or rent your personal information to third parties.
            </p>
          </div>
        </div>

        <div className="privacy-first-second">
          <div>
            <FaCookieBite
              style={{ fontSize: "30px", color: "var(--primary-color)" }}
            />
          </div>
          <div>
            <h1 className="p-h1">4. Cookies and Tracking</h1>
            <ul style={{ marginLeft: "25px" }}>
              <li>
                We use cookies and similar tracking technologies to enhance your
                experience on our website. These help us remember your
                preferences and track site usage. You may disable cookies
                through your browser, though some site features may be limited
                as a result.
              </li>
            </ul>
          </div>
        </div>

        <div className="privacy-first-second">
          <div>
            <FaDatabase
              style={{ fontSize: "30px", color: "var(--primary-color)" }}
            />
          </div>
          <div>
            <h1 className="p-h1">5. Data Security</h1>
            <ul style={{ marginLeft: "25px" }}>
              <li>
                We implement industry-standard security measures to protect your
                information. However, please note that no method of transmission
                over the internet is 100% secure, and we cannot guarantee
                absolute security.
              </li>
            </ul>
          </div>
        </div>

        <div className="privacy-first-second">
          <div>
            <MdPrivacyTip
              style={{ fontSize: "30px", color: "var(--primary-color)" }}
            />
          </div>
          <div>
            <h1 className="p-h1">6. Policy Updates</h1>
            <ul style={{ marginLeft: "25px" }}>
              <li>
                We may update this Privacy Policy from time to time. Any changes
                will be posted on this page with an updated "Last Updated" date.
                Continued use of the website after changes implies acceptance of
                the revised policy.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="privacy-last">
        <div>
          <h1 className="p-h1">Contact Us</h1>
          <p>
            For any questions regarding this Privacy Policy, please contact us
            at:
          </p>
          <ul style={{ marginLeft: "25px" }}>
            <li>+91 9129371733</li>
            <li>rk@drrkvishwakarma.com</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
